import ReportsApi from '../../apis/Reports';

export default {
    namespaced: true,
    state: {
        purchases: [],
        file_purchases: null,
        filters: null,
        purchase: null,
        detail: [],
        file_purchases_detail: null,
        file_name: null,
        paginated:{}
    },
    mutations: {
        set_purchases (state, data) {
            state.purchases = data;
        },
        set_file_purchases (state, value) {
            state.file_purchases = value;
        },
        set_filters (state, data) {
            state.filters = data;
        },
        set_purchase (state, data) {
            state.purchase = data;
        },
        set_detail (state, data) {
            state.detail = data;
        },
        set_file_purchases_detail (state, value) {
            state.file_purchases_detail = value;
        },
        set_file_name (state, value) {
            state.file_name = value;
        },
        set_paginated (state, data) {
            state.paginated =  data
        }
    },
    actions: {
        setPurchases ({commit}, data) {
            commit('set_purchases', data);
        },
        emptyFilePurchases ({commit}) {
            commit('set_file_purchases', null);
        },
        emptyFilePurchaseDetail ({commit}) {
            commit('set_file_purchases_detail', null);
        },
        setFilters ({commit}, data) {
            commit('set_filters', data);
        },
        selectPurchase ({commit}, data) {
            commit('set_purchase', data);
        },
        async getPurchases({commit, dispatch}, filters) {
            commit('set_purchases', []);
            return await ReportsApi.get_allPaginated(filters)
                        .then( response => {
                            commit('set_paginated', {
                                ...response.data
                            })
                            commit('set_purchases', response.data.data);
                        })
                        .catch( error => {
                            if (error.response?.status === 401) return null
                            dispatch('notifications/store_notification', {
                                type: 'error',
                                message: 'Ocurrió un error al listar compras, vuelva a intentarlo.'
                            }, {root: true});
                        })
        },
        async getPurchasesDetail({commit, dispatch}, purchase) {
            commit('set_detail', []);
            return await ReportsApi.getPurchasesDetail(purchase)
                        .then( response => {
                            commit('set_detail', response.data);
                        })
                        .catch( error => {
                            if (error.response?.status === 401) return null
                            dispatch('notifications/store_notification', {
                                type: 'error',
                                message: 'Ocurrió un error al listar detalle de compra, vuelva a intentarlo.'
                            }, {root: true});
                        })
        },
        async purchasesExcel({commit, dispatch}, filters) {
            commit('set_file_name', null);
            return await ReportsApi.purchasesExcel(filters)
                .then( response => {
                    commit('set_file_name', response.data.file_name);
                })
                .catch( error => {
                    if (error.response?.status === 401) return null
                    dispatch('notifications/store_notification', {
                        type: 'error',
                        message: 'Ocurrió un error al descargar reporte de compras, vuelva a intentarlo.'
                    }, {root: true});
                })
        },
        async purchaseDetailExcel({commit, dispatch}, purchase) {
            commit('set_file_purchases_detail', null);
            return await ReportsApi.detailExcel(purchase)
                        .then( response => {
                            commit('set_file_purchases_detail', response.data.file_purchases_detail);
                        })
                        .catch( error => {
                            if (error.response?.status === 401) return null
                            dispatch('notifications/store_notification', {
                                type: 'error',
                                message: 'Ocurrió un error al descargar detalle de compra, vuelva a intentarlo.'
                            }, {root: true});
                        })
        },
    }
}